import { useEffect, useRef, useState } from 'react';

import {
  SecretLinkModal,
  type SecretLinkModalApi,
} from '@pages/Organizations/OrganizationsList/components/SectretLinkModal';
import {
  SelectOrganizationUserModal,
  type SelectOrganizationUserModalApi,
} from '@pages/Organizations/OrganizationsList/components/SelectUserModal';

import type { GetSecretParams } from '@pages/Organizations/OrganizationsList/types';

export const useSecretLink = () => {
  const selectOrganizationUserModalRef =
    useRef<SelectOrganizationUserModalApi>(null);
  const secretLinkModalRef = useRef<SecretLinkModalApi>(null);

  const [data, setData] = useState<GetSecretParams>();

  const changeData = (data: GetSecretParams) => {
    if (data) {
      const { databaseId, forUserId } = data;
      setData({ databaseId, forUserId });
      selectOrganizationUserModalRef?.current?.clear();
    }
  };

  const renderUserSelectModal = () => (
    <SelectOrganizationUserModal
      closeCb={changeData}
      ref={selectOrganizationUserModalRef}
    />
  );

  const renderSecretLinkModal = () => (
    <SecretLinkModal ref={secretLinkModalRef} />
  );

  useEffect(() => {
    if (data) {
      secretLinkModalRef?.current?.open(data);
    }
  }, [data]);

  return {
    openSelectModal: selectOrganizationUserModalRef?.current?.open,
    renderUserSelectModal,
    renderSecretLinkModal,
  };
};
